import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { environment } from "environments/environment";


@Component({
    selector: "dodo-id-verification-failure-dialog",
    templateUrl: "./id-verification-failure-dialog.component.html",
    styleUrls: ["./id-verification-failure-dialog.component.scss"],
    standalone: false
})
export class IdVerificationFailureDialogComponent implements OnInit {
	public customerName: string;
	_source = "simkit";

	constructor(
		public dialogRef: MatDialogRef<IdVerificationFailureDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: string
	) {
	}

	ngOnInit() {
		this.redirectBackToMain();
	}

    private redirectBackToMain(): void {
        history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', (e) => {
            this.gotoMainSite();
        });

    }
	public continueClicked() {
		console.log("continue button clicked ...");
	}

	public closeDialog(): void {
		this.dialogRef.close();
	}

	public gotoMainSite(): void {
		window.location.href = environment[environment.envConfigName.env].durpalApiHost;
	}

	public gotoSupportPage(): void {
		window.location
	}
}
